import { createContext, ReactNode, useContext } from "react";

const PreviewViewportContext = createContext<number | undefined>(undefined);

type PreviewViewportProviderProps = {
  width: number;
  children: ReactNode;
};

export const PreviewViewportProvider = ({ width, children }: PreviewViewportProviderProps) => (
  <PreviewViewportContext.Provider value={width}>{children}</PreviewViewportContext.Provider>
);

export const usePreviewViewportWidth = () => useContext(PreviewViewportContext);
